import { useState } from "react";
import { toast } from "sonner";
import { ChevronDown, Loader2, ArrowUpRight } from "lucide-react";

export const Field = ({ label, name, testId, type = "text", required = false, placeholder = "", textarea = false }) => (
  <div>
    <label className="field-label" htmlFor={name}>
      {label}{required && <span className="text-[#1E3A8A]"> *</span>}
    </label>
    {textarea ? (
      <textarea id={name} name={name} rows={4} required={required} placeholder={placeholder} data-testid={testId} className="field resize-none" />
    ) : (
      <input id={name} name={name} type={type} required={required} placeholder={placeholder} data-testid={testId} className="field" />
    )}
  </div>
);

export const SelectField = ({ label, name, testId, required = true, children }) => (
  <div>
    <label className="field-label" htmlFor={name}>
      {label}{required && <span className="text-[#1E3A8A]"> *</span>}
    </label>
    <div className="relative">
      <select id={name} name={name} required={required} data-testid={testId} className="field cursor-pointer appearance-none pr-8">
        {children}
      </select>
      <ChevronDown size={16} className="pointer-events-none absolute right-1 top-1/2 -translate-y-1/2 text-[#1E3A8A]/70" />
    </div>
  </div>
);

export const Option = ({ value, children }) => (
  <option value={value} className="bg-white text-[#0F172A]">{children}</option>
);

export const SubmitButton = ({ loading, testId, children }) => (
  <button
    type="submit"
    disabled={loading}
    data-testid={testId}
    className="btn-gold w-full disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:translate-y-0"
  >
    {loading ? <Loader2 size={16} className="animate-spin" /> : <>{children} <ArrowUpRight size={16} /></>}
  </button>
);

export const PlaceholderNote = ({ testId }) => (
  <p data-testid={testId} className="mt-4 text-center font-sans text-[10px] tracking-[0.15em] text-[#CBD5E1]">
    FOUNDATION PREVIEW — SUBMISSIONS ARE NOT YET STORED
  </p>
);

export const usePlaceholderSubmit = (title, description) => {
  const [loading, setLoading] = useState(false);
  const onSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      form.reset();
      toast.success(title, { description });
    }, 1200);
  };
  return { loading, onSubmit };
};
